import React, { useEffect } from "react";
import "./NatureScienceModal.css";

const icons = {
  buildingBlocks: (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polygon points="32,4 56,18 56,46 32,60 8,46 8,18" stroke="#4a7c59" strokeWidth="2.5" fill="rgba(74,124,89,0.1)" />
      <circle cx="32" cy="32" r="6" fill="#4a7c59" />
      <circle cx="32" cy="14" r="4" fill="#6ba37a" />
      <circle cx="48" cy="23" r="4" fill="#6ba37a" />
      <circle cx="48" cy="41" r="4" fill="#6ba37a" />
      <circle cx="32" cy="50" r="4" fill="#6ba37a" />
      <circle cx="16" cy="41" r="4" fill="#6ba37a" />
      <circle cx="16" cy="23" r="4" fill="#6ba37a" />
      <line x1="32" y1="26" x2="32" y2="18" stroke="#4a7c59" strokeWidth="1.5"/>
      <line x1="37" y1="29" x2="44" y2="25" stroke="#4a7c59" strokeWidth="1.5"/>
      <line x1="37" y1="35" x2="44" y2="39" stroke="#4a7c59" strokeWidth="1.5"/>
      <line x1="32" y1="38" x2="32" y2="46" stroke="#4a7c59" strokeWidth="1.5"/>
      <line x1="27" y1="35" x2="20" y2="39" stroke="#4a7c59" strokeWidth="1.5"/>
      <line x1="27" y1="29" x2="20" y2="25" stroke="#4a7c59" strokeWidth="1.5"/>
    </svg>
  ),
  energyMetabolism: (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 8 C18 8 8 18 8 32" stroke="#4a7c59" strokeWidth="3" strokeLinecap="round" fill="none"/>
      <path d="M8 32 C8 46 18 56 32 56" stroke="#6ba37a" strokeWidth="3" strokeLinecap="round" fill="none"/>
      <path d="M32 56 C46 56 56 46 56 32" stroke="#4a7c59" strokeWidth="3" strokeLinecap="round" fill="none"/>
      <path d="M56 32 C56 18 46 8 32 8" stroke="#6ba37a" strokeWidth="3" strokeLinecap="round" fill="none"/>
      <polygon points="8,24 8,40 2,32" fill="#4a7c59"/>
      <polygon points="56,24 56,40 62,32" fill="#4a7c59"/>
      <path d="M36 20 L28 32 H34 L28 44" stroke="#f59e0b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
  ),
  bioactiveCompounds: (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 8 C32 8 16 20 16 36 C16 46 23 54 32 54 C41 54 48 46 48 36 C48 20 32 8 32 8Z" stroke="#4a7c59" strokeWidth="2.5" fill="rgba(74,124,89,0.1)"/>
      <path d="M32 54 L32 30" stroke="#4a7c59" strokeWidth="2" strokeLinecap="round"/>
      <path d="M32 38 C32 38 24 32 20 26" stroke="#6ba37a" strokeWidth="2" strokeLinecap="round"/>
      <path d="M32 44 C32 44 40 38 44 30" stroke="#6ba37a" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="20" cy="26" r="3" fill="#6ba37a"/>
      <circle cx="44" cy="30" r="3" fill="#6ba37a"/>
      <circle cx="32" cy="28" r="3" fill="#4a7c59"/>
    </svg>
  ),
  physiologicalBalance: (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="32" y1="10" x2="32" y2="54" stroke="#4a7c59" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="20" y1="54" x2="44" y2="54" stroke="#4a7c59" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="32" y1="18" x2="12" y2="26" stroke="#4a7c59" strokeWidth="2" strokeLinecap="round"/>
      <line x1="32" y1="18" x2="52" y2="26" stroke="#4a7c59" strokeWidth="2" strokeLinecap="round"/>
      <path d="M4 26 C4 26 12 30 12 34 C12 38 4 42 4 42" stroke="#6ba37a" strokeWidth="2" strokeLinecap="round" fill="none"/>
      <path d="M20 26 C20 26 12 30 12 34 C12 38 20 42 20 42" stroke="#6ba37a" strokeWidth="2" strokeLinecap="round" fill="none"/>
      <path d="M44 26 C44 26 52 30 52 34 C52 38 44 42 44 42" stroke="#6ba37a" strokeWidth="2" strokeLinecap="round" fill="none"/>
      <path d="M60 26 C60 26 52 30 52 34 C52 38 60 42 60 42" stroke="#6ba37a" strokeWidth="2" strokeLinecap="round" fill="none"/>
      <circle cx="32" cy="10" r="3" fill="#4a7c59"/>
    </svg>
  ),
};

const cards = [
  {
    key: "buildingBlocks",
    title: "BUILDING BLOCKS",
    desc: "– proteins, lipids, and minerals that form our cells",
  },
  {
    key: "energyMetabolism",
    title: "ENERGY METABOLISM",
    desc: "– carbohydrates and fats that fuel cellular processes",
  },
  {
    key: "bioactiveCompounds",
    title: "BIOACTIVE COMPOUNDS",
    desc: "– plant molecules that regulate biological pathways",
  },
  {
    key: "physiologicalBalance",
    title: "PHYSIOLOGICAL BALANCE",
    desc: "– nutrients that support immune and metabolic functions",
  },
];

const NatureScienceModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="ns-overlay" onClick={onClose}>
      <div className="ns-container" onClick={(e) => e.stopPropagation()}>
        <button className="ns-close" onClick={onClose}>&times;</button>

        {/* Header Image */}
        <div className="ns-header">
          <img
            src="https://storage.googleapis.com/rasai-nutrie-assets/tiles/tile-1.jpg"
            alt="We are made of what we eat"
          />
          <div className="ns-header-overlay">
            <h1>"WE ARE MADE OF WHAT WE EAT"</h1>
          </div>
        </div>

        {/* Scrollable Body */}
        <div className="ns-body">
          <h2 className="ns-title">"WE ARE MADE OF WHAT WE EAT"</h2>
          <p className="ns-intro">
            Every cell in the human body is built, repaired, and regulated by molecules derived from food.
            Food influences our biology through:
          </p>

          {/* Animated Icon Cards */}
          <div className="ns-cards">
            {cards.map((card, i) => (
              <div
                key={card.key}
                className="ns-card"
                style={{ animationDelay: `${i * 0.18}s` }}
              >
                <div className="ns-icon">{icons[card.key]}</div>
                <h3>{card.title}</h3>
                <p>{card.desc}</p>
              </div>
            ))}
          </div>

          {/* Bullet Points */}
          <ul className="ns-bullets">
            <li><strong>Building blocks</strong> – proteins, lipids, and minerals that form our cells</li>
            <li><strong>Energy metabolism</strong> – carbohydrates and fats that fuel cellular processes</li>
            <li><strong>Bioactive compounds</strong> – plant molecules that regulate biological pathways</li>
            <li><strong>Physiological balance</strong> – nutrients that support immune and metabolic functions</li>
          </ul>

          {/* Quote */}
          <blockquote className="ns-quote">
            "In essence, the foods we eat provide both the structural building blocks and the regulatory signals that shape human biology."
          </blockquote>

          {/* Closing */}
          <p className="ns-closing">
            Understanding this connection between food and cellular function allows us to design foods and botanical formulations that support health at a molecular level.
          </p>

          <button className="ns-back-btn" onClick={onClose}>Back to Home</button>
        </div>
      </div>
    </div>
  );
};

export default NatureScienceModal;
